<template>
  <div>
    <section id="about">
      <b-jumbotron bg-variant="white" fluid header="About Us">
        <p>We offer a simple and convenient way for individuals and businesses to top up mobile phones, purchase data
          plans, and pay bills online, across borders.</p>
        <p>At Umbai, we understand the importance of staying connected with loved ones, no matter where you are in the
          world. With our services, you can easily send airtime and data to friends and family abroad, ensuring that you
          can always stay in touch.</p>
      </b-jumbotron>
    </section>
    <section id="developers">
      <b-jumbotron fluid header="API for Developers">
        <p>As a developer, you can integrate Umbai's services into your own applications using our API. Our API is
          easy to use and well-documented, with a wide range of functionality including:</p>
        <ul>
          <li>Airtime top-up</li>
          <li>Data plan purchase</li>
          <li>Bill payment</li>
        </ul>
        <p>
          <a target="_blank" href="https://documentation.umbai.africa"
            class="btn btn-neutral  btn-round btn-lg" data-toggle="tooltip"
            data-original-title="Follow us">EXPLORE THE DEVELOPER DOCS</a>
          </p>
        <p>To learn more and get started, send an email to support@umbai.co.za</p>
      </b-jumbotron>
    </section>
    <section id="partners">
      <b-jumbotron bg-variant="white" fluid header="Some of our Partners" lead="Who make this possible">
        <b-row>
          <b-col><img src="logo/airtel.png" alt="airtel" /></b-col>
          <b-col><img src="logo/taura.jpg" alt="Taura" /></b-col>
          <b-col><img src="logo/econet.jpg" alt="Econet" /></b-col>

          <b-col><img src="logo/tnm.png" alt="airtel" /></b-col>
        </b-row>
      </b-jumbotron>
    </section>
    <section id="contact">
      <b-jumbotron fluid header="Contact Us">
        <b-row>
          <b-col>Call us: +27 67 740 5859 /<br /> +27 87 702 0660</b-col>
          <b-col>Whatsapp Us: +27 67 740 5859</b-col>
          <b-col>Email Us: support@umbai.co.za </b-col>
        </b-row>
      </b-jumbotron>
    </section>
    <div class="container">
      <div class="row">

        <div class="col-lg-6">
          <h3 class="text-primary font-weight-light mb-2">Thank you for supporting us!</h3>
          <h4 class="mb-0 font-weight-light">Let's get in touch on any of these platforms.</h4>
        </div>
        <div class="col-4 text-lg-center btn-wrapper">
          <a target="_blank" href="https://www.linkedin.com/company/umbairealities/"
            class="btn btn-neutral btn-icon-only btn-round btn-lg" data-toggle="tooltip"
            data-original-title="Follow us">
            <i class="fa fa-linkedin"></i>
          </a>
          <a target="_blank" href="https://www.facebook.com/umbai.co.za"
            class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip"
            data-original-title="Like us">
            <i class="fa fa-facebook-square"></i>
          </a>
        </div>
      </div>
      <hr />
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-6">
          <div class="copyright">
            &copy; {{ year }}
            Umbai all rights reserved
          </div>
        </div>
        <div class="col-md-6">
          <ul class="nav nav-footer justify-content-end">
            <li class="nav-item">
              <router-link to="/" class="nav-link">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/Terms" class="nav-link">Terms</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/Privacy" class="nav-link">Privacy</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app-footer",
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>




